<template>
    <div>
        <div class="row">
            <div class="col-md-12 card-wrapper">
                <div class="card">
                    <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('OFFER_TEMPLATES')}}</div>
                    <div class="card-body bg-light">
                        <div class="row mt-2">
                            <div class="align-self-center col-12 ">
                                <button type="button" class="btn bg-new-primary  px-2 text-center text-white" @click="createNewTemplate()">Yeni Şablon Oluştur</button>  
                            </div>       
                        </div>

                        <div class="personTable mt-4">
                            
                            <table class="table table-striped table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>{{$ml.get('TEMPLATE_NAME')}}</th>
                                        <th>{{$ml.get('NOTE')}}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="i in emailTemplates">
                                        <td> 
                                            <div class="radio mt-2">
                                                <label><input class="mr-2" type="radio" id='regular' name="optradio">{{i.name}}</label>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td>
                                            <div class="d-flex">
                                                <button class="btn-new btn-primary mr-2 ml-1" @click="updateEmailTemplate(i._id)">
                                                    <span class="fas fa-pen" style="font-family: 'Font Awesome 5 Free';"></span>
                                                </button>
                                                <button class="btn-new btn-danger" @click="deleteEmailTemplate(i._id)">
                                                    <span class="fa fa-trash"></span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>



<script>

import Vue from 'vue';
import axios from 'axios'
import {mapGetters} from 'vuex'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import data from '../../static/js/data';

    export default {
        components: {
       
        },
        data () {
            return {
                emailTemplates:[],
            }
    },
    watch: {
        
    },
    computed:{
          ...mapState([
              'baseUrl'
          ]),
          ...mapGetters(["localeLang"]),
          
         
    },
    methods:{
        getEmailTemplates() {
            axios({
                method:'POST',
                url:'/getEmailTemplates',
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    this.emailTemplates = res.data.content.email_templates;
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        deleteEmailTemplate(templateId) {
            axios({
                method:'POST',
                url:'/deleteEmailTemplates',
                baseURL: this.baseUrl,
                data: {
                    templateIds: [templateId]
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                console.log("delete: OK")
                this.getEmailTemplates()
                }else{
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc
                })
                }
            })
        },
        updateEmailTemplate(id){
            if(id!==""&&id!=null){
                window.open('/emailTemplateEditor/' + id , '_blank');
            }
            
        },
        createNewTemplate(){
            window.open('/emailTemplateEditor/' + 'new' , '_blank');
        },
    },
    
    mounted(){
       this.getEmailTemplates()
    }
}
</script>



<style scoped>
    * {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
.card{
    min-height: 700px;
}
.personTable {
    max-height: 495px;
    /* min-width: 655px; */
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;
    border: 1px solid rgb(218, 218, 218);
    border-radius: 4px;
}
th {
    background: white;
    position: sticky;
    top: 0;
}
.table td, .table th{
    font-size: 15px;
    padding: 1rem;
    border: none;
    border-bottom: 1px solid rgb(218 218 218);
}
.table thead tr th:first-child{
    width: 300px;
    color: #7E8086;
    border-right: 1px solid rgb(218 218 218);
} 
.table thead tr th:nth-child(2){
    width: 390px;
    color: #7E8086;
    border-right: 1px solid rgb(218 218 218);
}
.table tbody tr td{
    border-right: 1px solid rgb(218 218 218);
    color: #53565E;
    font-size: 14px;
}
.table-striped tbody tr:nth-of-type(odd){
    background-color: #F4F4F4;
}
.btn-new{
    width: 30px;
    height: 30px;
}


</style>